// refundMutationSlice.js
import { apiSlice } from "../apiSlice";

export const refundMutationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    patchRefundStatus: builder.mutation({
      query: ({ id, status, remarks }) => ({
        url: `refunds/${id}`,
        method: "PATCH",
        body: { shipment_id: id, status, remarks },
      }),

      async onQueryStarted(
        { id, status, remarks, filters },
        { dispatch, queryFulfilled }
      ) {
        try {
          const { data: updatedRefund } = await queryFulfilled;

          // update normalized cache from refundListSlice
          dispatch(
            apiSlice.util.updateQueryData(
              "getRefundList",
              filters || {},
              (draft) => {
                const existing = draft.entities[id];
                if (existing) Object.assign(existing, updatedRefund);
              }
            )
          );
        } catch (e) {
          console.error("Refund update failed:", e);
        }
      },

      invalidatesTags: (result, error, { id }) => [
        { type: "refund", id },
        { type: "refund", id: "refundList" },
      ],
    }),
  }),
});

export const { usePatchRefundStatusMutation } = refundMutationApiSlice;
